class HomeHeaderSlider {
	constructor($el) {
		this.$el = $el;

		this.options = {
			autoPlay: true,
			pageDots: true,
			wrapAround: true,
			prevNextButtons: false,
			freeScroll: false,
			setGallerySize: false,
			fade: true,
			cellSelector: ".homepage-header__slide",
			arrowShape: {
				x0: 15,
				x1: 60,
				y1: 50,
				x2: 65,
				y2: 50,
				x3: 20,
			},
		};

		if (this.$el.length) {
			this._createSlider();
		}
	}

	_createSlider() {
		this.$el.flickity(this.options);
	}
}

export default HomeHeaderSlider;
